import { endpoints, useApi } from 'api';
import { cleanObj } from 'library';
import { useEffect, useState } from 'react';

const useFetchTransactions = (caseId, params) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, toggleLoading] = useState(false);

    const [api] = useApi();

    useEffect(() => {
        const fetchTransactions = async (caseId) => {
            if (!caseId) return;

            try {
                toggleLoading(true);
                const req = await api({
                    url: endpoints.PLAID_TRANSACTIONS,
                    params: {
                        cs_id: caseId,
                        ...cleanObj(params),
                    },
                });

                const res = await req.data;

                if (Array.isArray(res) && res.length) {
                    setTransactions(res);
                }
                toggleLoading(false);
            } catch (error) {
                console.log({ error });
                toggleLoading(false);
            }
        };

        fetchTransactions(caseId);
    }, [api, caseId, params]);

    return [transactions, loading];
};

export default useFetchTransactions;
